module.exports = __webpack_public_path__ + "static/media/green-arrow.15443b92.svg";